export default (getView) =>
  ({ nextStepPath, formFields }) => ({
    ...getView({
      nextStepPath,
      formFields,
    }),

    init() {
      this.commonInit()

      this.store.values.marketingAgreed = false
      this.store.values.privacyAgreement = false
    },

    handleSubmit() {
      // Agreements are set here automatically as per products requirement.
      // On UI there is a text that user agrees by pressing 'next' button.
      this.store.values.marketingAgreed = true
      this.store.values.privacyAgreement = true
      this.submit({ push: true, isEmailStep: true })
    },
  })
